module.exports = __webpack_public_path__ + "static/media/male.1d529ae6.svg";